<template lang="pug">
  sui-table(:columns="statTypes.length + 1")
    sui-table-header
      sui-table-row
        sui-table-header-cell(text-align="center")
          sui-image(
            centered,
            size="mini",
            :src="logo")

        sui-table-header-cell(
          text-align="center",
          v-for="stat in statTypes",
          :key="stat.key") {{ stat.name }}

    sui-table-body
      sui-table-row(
        v-for="player in displayedPlayers",
        :key="player.info.playerId")
        sui-table-cell(text-align="center") {{ player.info.gamertag }}
        sui-table-cell(
          text-align="center",
          v-for="stat in statTypes",
          :key="stat.key") {{ player.stats[stat.key] | rounded }}

      sui-table-row(v-if="stats.length === 0")
        sui-table-cell(
          :colspan="statTypes.length + 1",
          text-align="center")
          sui-header(
            size="huge",
            icon)
            sui-icon(name="frown outline")
            sui-header-subheader No Data Available
</template>

<script>
export default {
  name: 'PlayerStats',
  props: {
    logo: {
      required: true,
    },
    stats: {
      required: true,
    },
    statTypes: {
      required: true,
    },
  },
  computed: {
    displayedPlayers() {
      return this.stats
        .slice(0)
        .sort((a, b) => a.info.gamertag.localeCompare(b.info.gamertag, { sensitivity: 'base' }));
    },
  },
  filters: {
    rounded(value) {
      return Math.round(value);
    },
  },
};
</script>
